import React from "react";
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import hero1 from '../../images/main-slider/bg.png'
import hero2 from '../../images/main-slider/bg2.png'
import hero3 from '../../images/main-slider/bg3.png'
import hero4 from '../../images/main-slider/bg4.png'
import hero5 from '../../images/main-slider/bg5.png'
import ptn from '../../images/main-slider/pattern-2.png'
import ptn2 from '../../images/main-slider/pattern-1.png'

const Hero = () => {

    var settings = {
        dots: false,
        arrows: true,
        speed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        autoplay: true,
    };


    return (
        <section className="slider-one" id="home">
            <div className="slider-one_pattern-two" style={{ backgroundImage: `url(${ptn})` }}></div>
            <div className="main-slider-carousel">
                <Slider {...settings}>
                    {/*  Slide 05 */}
                    <div className="slider-one_slide">
                        <div className="slider-one_image-layer" style={{ backgroundImage: `url(${hero5})` }}></div>
                        <div className="slider-one_pattern" style={{ backgroundImage: `url(${ptn2})` }}></div>
                        <div className="auto-container">

                            {/*  Content Column */}
                            <div className="slider-one_content">
                                <div className="slider-one_content-inner">
                                    <div className="slider-one_title">Georgies Retreat ECO Camp</div>
                                    <div className="slider-one_date"><span>17</span> May <br /> 2026</div>
                                    <h1 className="slider-one_heading">Brains & Brews <br /> 102</h1>
                                    <div className="slider-one_buttons">
                                        <Link to="https://forms.gle/yKPxTmVe2xcxaw4Z8" className="theme-btn btn-style-one">
                                            <span className="btn-wrap">
                                                <span className="text-one">Request Your Invite</span>
                                                <span className="text-two">Request Your Invite</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/*  End Slide 05 */}

                    {/*  Slide 01 */}
                    <div className="slider-one_slide">
                        <div className="slider-one_image-layer" style={{ backgroundImage: `url(${hero1})` }}></div>
                        <div className="slider-one_pattern" style={{ backgroundImage: `url(${ptn2})` }}></div>
                        <div className="auto-container">

                          
                            <div className="slider-one_content">
                                <div className="slider-one_content-inner">
                                    <div className="slider-one_title">SHOTS, Guwahati</div>
                                    <div className="slider-one_date"><span>22</span> June <br /> 2025</div>
                                    <h1 className="slider-one_heading">Brains and Brews <br />101 </h1>
                                    <div className="slider-one_buttons">
                                        <div className="theme-btn btn-style-one" style={{ pointerEvents: 'none', opacity: 0.7 }}>
                                            <span className="btn-wrap">
                                                <span className="text-one">Event Completed</span>
                                                <span className="text-two">Event Completed</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/*  End Slide 01 */}

                    {/*  Slide 02 */}
                    <div className="slider-one_slide">
                        <div className="slider-one_image-layer" style={{ backgroundImage: `url(${hero3})` }}></div>
                        <div className="slider-one_pattern" style={{ backgroundImage: `url(${ptn2})` }}></div>
                        <div className="auto-container">

                            {/*  Content Column */}
                            <div className="slider-one_content">
                                <div className="slider-one_content-inner">
                                    <div className="slider-one_title">Mawkdok Village, Meghalaya</div>
                                    <div className="slider-one_date"><span>19</span> June <br /> 2026</div>
                                    <h1 className="slider-one_heading">Z_Meghalaya <br /> The Reset Project</h1>
                                    <div className="slider-one_buttons">
                                        <Link to="/zentara" className="theme-btn btn-style-one">
                                            <span className="btn-wrap">
                                                <span className="text-one">Know More</span>
                                                <span className="text-two">Know More</span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/*  End Slide 02 */}

                    {/*  Slide 03 */}
                    <div className="slider-one_slide">
                        <div className="slider-one_image-layer" style={{ backgroundImage: `url(${hero4})` }}></div>
                        <div className="slider-one_pattern" style={{ backgroundImage: `url(${ptn2})` }}></div>
                        <div className="auto-container">

                            {/*  Content Column */}
                            <div className="slider-one_content">
                                <div className="slider-one_content-inner">
                                    <div className="slider-one_title">Zen Nest Rooftop</div>
                                    <div className="slider-one_date"><span>10</span> August <br /> 2025</div>
                                    <h1 className="slider-one_heading">SkillSwap <br /> Social</h1>
                                    <div className="slider-one_buttons">
                                        <div className="theme-btn btn-style-one" style={{ pointerEvents: 'none', opacity: 0.7 }}>
                                            <span className="btn-wrap">
                                                <span className="text-one">Event Completed</span>
                                                <span className="text-two">Event Completed</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* End Slide 03 */}
                    {/* Slide 04 */}
                    <div className="slider-one_slide">
                        <div className="slider-one_image-layer" style={{ backgroundImage: `url(${hero2})` }}></div>
                        <div className="slider-one_pattern" style={{ backgroundImage: `url(${ptn2})` }}></div>
                        <div className="auto-container">
                            {/*  Content Column */}
                            <div className="slider-one_content">
                                <div className="slider-one_content-inner">
                                    <div className="slider-one_title">Shergaon, Arunachal Prades</div>
                                    <div className="slider-one_date"><span>22</span> November <br /> 2025</div>
                                    <h1 className="slider-one_heading">Z_Arunachal <br /> The Connect Tour</h1>
                                    <div className="slider-one_buttons">
                                        <div className="theme-btn btn-style-one" style={{ pointerEvents: 'none', opacity: 0.7 }}>
                                            <span className="btn-wrap">
                                                <span className="text-one">Event Completed</span>
                                                <span className="text-two">Event Completed</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Slide 04 */}
                </Slider>

            </div>
        </section>
    )
}



export default Hero;